export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const CONSUMER_URL = process.env.REACT_APP_CONSUMER_URL;
export const EXTRACTION_URL = process.env.REACT_APP_EXTRACTION_URL;

export const OAUTH_URL = "https://snap.nimbleproperty.net/auth";
